import app from '$$app';
import InlineEditors from '../../controllers/inlineEditors';
import GridRows from '../../grid/rows';

export default instance => {
  const helper = instance.utils.dom;

  instance.attachEvent('onEmptyClick', event => {
    if (InlineEditors.isActive()) {
      InlineEditors.onClick();
    }

    if (event && helper.closest(event.target, '.gantt_task_row')) {
      const node = helper.locateAttribute(event.target, instance.config.task_attribute);
      const taskId = node ? node.getAttribute(instance.config.task_attribute) : null;

      taskId && GridRows.onTaskClick(taskId, event);
    }

    app.trigger('gantt:area:click');
  });
};
